export default "__VITE_ASSET__2w223ZbT__"